/** Browser tab / history suffix for all in-app pages. */
export const SITE_TITLE = 'Xosa Origin'

export const DEFAULT_DOCUMENT_TITLE = SITE_TITLE

/** `{page} - Xosa Origin`, or just `Xosa Origin` when `pageTitle` is empty. */
export function formatPageTitle(pageTitle: string): string {
  const trimmed = pageTitle.trim()
  if (!trimmed) return SITE_TITLE
  return `${trimmed} - ${SITE_TITLE}`
}
